module.exports = __webpack_public_path__ + "media/assets/faria_products/OA-2e7923f560d7b72bd48f02a78d28358173bcdf6f276b30c92c467705d6020fe6.png";